export default "__VITE_ASSET__8x$2eQTG__"